import styles from "./IconSelect.module.css";

type IconSelectProps = {
  width?: number;
  height?: number;
};

export default function IconSelect({ width = 8, height = 4 }: IconSelectProps) {

  return (
    <svg className={styles.iconSelect} width={width} height={height} viewBox="0 0 8 4" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g id="select">
        <path
          d="M3.35308 3.73913L0.949499 1.47826C0.656755 1.2029 0.591427 0.887826 0.753515 0.533043C0.914986 0.177681 1.20372 0 1.61973 0H6.38068C6.79668 0 7.08542 0.177681 7.24689 0.533043C7.40898 0.887826 7.34365 1.2029 7.05091 1.47826L4.64732 3.73913C4.55488 3.82609 4.45473 3.8913 4.34687 3.93478C4.23902 3.97826 4.12346 4 4.0002 4C3.87694 4 3.76139 3.97826 3.65353 3.93478C3.54568 3.8913 3.44553 3.82609 3.35308 3.73913Z"
        />
      </g>
    </svg>
  );
}
